import Tooltip, { TooltipTrigger } from "components/Tooltip/Tooltip";
import styled from "styled-components";

interface RequestsProps {
  $fullWidth: boolean;
}

export const Requests = styled.div<RequestsProps>`
  display: ${({ $fullWidth }) => ($fullWidth ? "flex" : "inline-flex")};
  align-items: center;
  gap: 6px;

  & > ${TooltipTrigger} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    line-height: 0;
  }

  ${({ $fullWidth }) => ($fullWidth ? "width: 100%;" : null)}

  ${({ theme }) => theme.md`
        justify-content: flex-end;
      `}
`;

interface ServiceTooltipProps {
  $zIndex: number;
}

export const ServiceTooltip = styled(Tooltip)<ServiceTooltipProps>`
  z-index: ${({ $zIndex }) => $zIndex} !important;
`;
